module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('container', [_c('h1', {
    staticStyle: {
      "font-size": "25px",
      "marging-top": "20px",
      "margin-bottom": "30px",
      "text-align": "center"
    }
  }, [_vm._v("Total Participants")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-bottom": "80px"
    }
  }, [_c('date-range-field', {
    model: {
      value: (_vm.rangeData),
      callback: function($$v) {
        _vm.rangeData = $$v
      },
      expression: "rangeData"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "tp-table"
  }, [_c('v-table', {
    staticStyle: {
      "width": "100%",
      "font-size": "11px"
    },
    attrs: {
      "is-loading": _vm.loading,
      "is-horizontal-resize": "",
      "columns": _vm.columns,
      "table-data": _vm.tableData,
      "show-vertical-border": true,
      "title-row-height": 30,
      "border": 1,
      "footer": _vm.footer,
      "footer-row-height": 40,
      "footer-cell-class-name": _vm.setFooterCellClass,
      "row-hover-color": "#eee",
      "row-click": _vm.raceDetail
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "mt20 mb20 bold",
    staticStyle: {
      "padding-top": "25px"
    }
  }, [_c('v-pagination', {
    attrs: {
      "total": _vm.pageTotal,
      "pageIndex": _vm.pageIndex + 1,
      "page-size": _vm.pageSize,
      "layout": ['total', 'prev', 'pager', 'next', 'sizer', 'jumper']
    },
    on: {
      "page-change": _vm.pageChange,
      "page-size-change": _vm.pageSizeChange
    }
  })], 1)], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0a7cdb70"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/LiveRun/Race/TP.vue
// module id = 1629
// module chunks = 1